import Zoid from './zoid'
import Internal from './internal'

const reducers = {
    [Zoid.store]: Zoid.reducer,
    [Internal.store]: Internal.reducer,
}

export const initialStates = {
    [Zoid.store]: Zoid.initialState,
    [Internal.store]: Internal.initialState,
}

export default reducers
